import { render, staticRenderFns } from "./WxPaySetting.vue?vue&type=template&id=b2aabf10&scoped=true"
import script from "./WxPaySetting.vue?vue&type=script&lang=js"
export * from "./WxPaySetting.vue?vue&type=script&lang=js"
import style0 from "./WxPaySetting.vue?vue&type=style&index=0&id=b2aabf10&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2aabf10",
  null
  
)

export default component.exports